import React, { useState } from "react";
import Logo from "./Logo";

const LoginScreen = ({ onAuthenticated }) => {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL || ""}/api/auth/verify`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ access_code: code }),
        }
      );

      if (res.ok) {
        const data = await res.json();
        onAuthenticated(data.token);
      } else {
        setError("Invalid access code. Please try again.");
      }
    } catch {
      setError("Unable to connect to the server. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logoWrap}>
          <Logo height={44} />
        </div>
        <h2 style={styles.title}>Shop Masters Upload Portal</h2>
        <p style={styles.subtitle}>
          Enter your access code to upload data assets.
        </p>

        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            type="password"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="Access code"
            style={styles.input}
            autoFocus
            required
          />
          {error && <p style={styles.error}>{error}</p>}
          <button
            type="submit"
            disabled={loading || !code}
            style={{
              ...styles.button,
              opacity: loading || !code ? 0.6 : 1,
            }}
          >
            {loading ? "Verifying…" : "Continue"}
          </button>
        </form>
      </div>
      <p style={styles.footer}>
        Protected by AnswerMyQ &middot; All uploads are encrypted in transit
      </p>
    </div>
  );
};

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #0f0f1a 0%, #1a1a2e 100%)",
    padding: 24,
  },
  card: {
    background: "#ffffff",
    borderRadius: 16,
    padding: "48px 40px",
    width: "100%",
    maxWidth: 420,
    boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
  },
  logoWrap: {
    display: "flex",
    justifyContent: "center",
    marginBottom: 24,
  },
  title: {
    margin: 0,
    fontSize: 20,
    fontWeight: 600,
    color: "#1a1a2e",
    textAlign: "center",
  },
  subtitle: {
    margin: "8px 0 28px",
    fontSize: 14,
    color: "#6b7280",
    textAlign: "center",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: 14,
  },
  input: {
    padding: "14px 16px",
    fontSize: 15,
    border: "1.5px solid #e0e0e0",
    borderRadius: 10,
    outline: "none",
    transition: "border-color 0.2s",
    fontFamily: "inherit",
  },
  error: {
    margin: 0,
    color: "#ef4444",
    fontSize: 13,
    textAlign: "center",
  },
  button: {
    padding: "14px",
    fontSize: 15,
    fontWeight: 600,
    color: "#fff",
    background: "#ff4f8b",
    border: "none",
    borderRadius: 10,
    cursor: "pointer",
    fontFamily: "inherit",
    transition: "opacity 0.2s",
  },
  footer: {
    marginTop: 24,
    fontSize: 12,
    color: "rgba(255,255,255,0.4)",
  },
};

export default LoginScreen;
